import type {ReactElement} from 'react'
import {useState} from 'react'

type Props = {
  children: (onToggle: () => void, open: boolean) => ReactElement
  initOpen?: boolean | null
}

export function Toggle({children, initOpen = false}: Props) {
  const [isOpen, setIsOpen] = useState(initOpen === true)

  const onToggle = () => {
    setIsOpen(!isOpen)
  }

  return children(onToggle, isOpen)
}
